module.exports = __webpack_public_path__ + "static/media/icon-file.5cd2b3d7.svg";